export default __webpack_public_path__ + "static/media/minus.1abb9d47.svg";